export default __webpack_public_path__ + "static/media/clear.84e14db0.svg";